// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IsQGBVZzAxVCeDeIk5Ae {
  color: white;
  text-shadow: rgb(0, 0, 0) 0 1px 3px, rgb(0, 0, 0) 0 -1px 3px, rgb(0, 0, 0) 1px 0 3px, rgb(0, 0, 0) -1px 0 3px;
  padding: 8px 12px;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  z-index: 1;
}
.IsQGBVZzAxVCeDeIk5Ae:hover {
  background: rgba(50, 50, 50, 0.4);
}
.IsQGBVZzAxVCeDeIk5Ae .jU6Go4oyKgVRJf8SIeW8 {
  max-width: 50vw;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 20px !important;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .IsQGBVZzAxVCeDeIk5Ae .jU6Go4oyKgVRJf8SIeW8 {
    max-width: 25vw;
  }
}
@media (max-width: 480px) {
  .IsQGBVZzAxVCeDeIk5Ae .jU6Go4oyKgVRJf8SIeW8 {
    max-width: 20vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/SceneEditTitle/SceneEditTitle.module.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,6GACE;EAIF,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AAJF;AAME;EACE,iCAAA;AAJJ;AAOE;EACE,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;AALJ;AAOI;EAPF;IAQI,eAAA;EAJJ;AACF;AAMI;EAXF;IAYI,eAAA;EAHJ;AACF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `IsQGBVZzAxVCeDeIk5Ae`,
	"title": `jU6Go4oyKgVRJf8SIeW8`
};
export default ___CSS_LOADER_EXPORT___;
